import { c as _c } from "react/compiler-runtime";
import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, useMemo, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { CardListItemGroup } from 'record-it-components/cardList/CardListItemGroup/CardListItemGroup';
import { LocationContentContainer } from 'record-it-components/location/LocationContentContainer/LocationContentContainer';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { useConstructionSiteUsageStatisticTools } from '../../../classes/entities/ConstructionSiteUsageStatistic/useConstructionSiteUsageStatisticTools';
import { ConstructionSiteToSelectListItem } from '../../constructionSite/ConstructionSiteToSelectListItem/ConstructionSiteToSelectListItem';
import { NearbyConstructionSitesToSelectList } from '../../constructionSite/NearbyConstructionSitesToSelectList/NearbyConstructionSitesToSelectList';
import { useConstructionSiteSelectedHandler } from './useConstructionSiteSelectedHandler';
export type CreateWorkTimeEntrySelectConstructionSitePageDefaultContentProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  constructionSites: Array<ConstructionSite>;
};
export const CreateWorkTimeEntrySelectConstructionSitePageDefaultContent: FunctionComponent<CreateWorkTimeEntrySelectConstructionSitePageDefaultContentProps> = React.memo(props => {
  const $ = _c(36);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let constructionSites;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      constructionSites,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = constructionSites;
    $[4] = remainingProps;
  } else {
    constructionSites = $[3];
    remainingProps = $[4];
  }
  const {
    t
  } = useTranslation();
  const {
    handleConstructionSiteSelected
  } = useConstructionSiteSelectedHandler();
  const usageStatisticTools = useConstructionSiteUsageStatisticTools();
  let t1;
  if ($[5] !== constructionSites || $[6] !== usageStatisticTools) {
    t1 = usageStatisticTools.getMostUsedConstructionSites(constructionSites).slice(0, 5);
    $[5] = constructionSites;
    $[6] = usageStatisticTools;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const mostUsedConstructionSites = t1;
  let t2;
  if ($[8] !== t) {
    t2 = t("components.page.CreateWorkTimeEntrySelectConstructionSitePage.groupHeaders.nearby");
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== constructionSites || $[11] !== handleConstructionSiteSelected) {
    t3 = <LocationContentContainer>{t4 => {
        const {
          locationInfo
        } = t4;
        return <NearbyConstructionSitesToSelectList constructionSites={constructionSites} currentLocation={locationInfo} onConstructionSiteSelected={handleConstructionSiteSelected} />;
      }}</LocationContentContainer>;
    $[10] = constructionSites;
    $[11] = handleConstructionSiteSelected;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <CardListItemGroup label={t2} data-testid="CreateWorkTimeEntrySelectConstructionSitePage.NearbyConstructionSites">{t3}</CardListItemGroup>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== handleConstructionSiteSelected || $[17] !== mostUsedConstructionSites || $[18] !== t) {
    t5 = mostUsedConstructionSites.length ? <CardListItemGroup label={t("components.page.CreateWorkTimeEntrySelectConstructionSitePage.groupHeaders.mostUsed")} data-testid="CreateWorkTimeEntrySelectConstructionSitePage.MostUsedConstructionSites">{mostUsedConstructionSites.map(constructionSite => <ConstructionSiteToSelectListItem key={EntityUtils.getTrackingKey(constructionSite)} constructionSite={constructionSite} onConstructionSiteSelected={handleConstructionSiteSelected} data-testid="CreateWorkTimeEntrySelectConstructionSitePage.MostUsedConstructionSite" />)}</CardListItemGroup> : null;
    $[16] = handleConstructionSiteSelected;
    $[17] = mostUsedConstructionSites;
    $[18] = t;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== mostUsedConstructionSites.length || $[21] !== t) {
    t6 = mostUsedConstructionSites.length ? t("components.page.CreateWorkTimeEntrySelectConstructionSitePage.groupHeaders.all") : "";
    $[20] = mostUsedConstructionSites.length;
    $[21] = t;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== constructionSites || $[24] !== handleConstructionSiteSelected) {
    let t8;
    if ($[26] !== handleConstructionSiteSelected) {
      t8 = constructionSite_0 => <ConstructionSiteToSelectListItem key={EntityUtils.getTrackingKey(constructionSite_0)} constructionSite={constructionSite_0} onConstructionSiteSelected={handleConstructionSiteSelected} data-testid="CreateWorkTimeEntrySelectConstructionSitePage.ConstructionSiteListItem" />;
      $[26] = handleConstructionSiteSelected;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    t7 = constructionSites.map(t8);
    $[23] = constructionSites;
    $[24] = handleConstructionSiteSelected;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[28] !== t6 || $[29] !== t7) {
    t8 = <CardListItemGroup label={t6}>{t7}</CardListItemGroup>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== remainingProps || $[32] !== t4 || $[33] !== t5 || $[34] !== t8) {
    t9 = <div {...remainingProps}>{t4}{t5}{t8}</div>;
    $[31] = remainingProps;
    $[32] = t4;
    $[33] = t5;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
});